import { get, isEmpty } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  loaded: false,
  records: [],
}

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.FETCH_PARENTS_SUCCESS:
      return {
        loaded: true,
        records: action.payload,
      }
    default:
      return state
  }
}

export const selectParents = (store) => get(store, 'parents.records', [])

export const getHasParents = (store) => !isEmpty(selectParents(store))
